import facePageStyles from '../views/facePageStyles';

const activityListStyles = (theme) => ({
  ...facePageStyles(theme),
  activityItem: {
    transition: 'margin .3s',
    backgroundColor: '#fff',
    position: 'relative',
    minHeight: '84px',
    '&$activityItem_note:not(.isExpanded)': {
      cursor: 'pointer',
    },
    '&$activityItem_correspondence:not(.isExpanded)': {
      cursor: 'pointer',
    },
    '&$activityItem_meeting:not(.isExpanded)': {
      cursor: 'pointer',
    },
    '&$activityItem_note, &$activityItem_correspondence, &$activityItem_meeting': {
      '& $activityItem_header': {
        cursor: 'pointer',
      },
      '&.isExpanded': {
        '& $activityItem_content': {
          maxHeight: 'none',
          paddingRight: '52px',
        },
      },
      '& $activityItem_content': {
        maxHeight: '44px',
        '&>$textArea': {
          border: '0 #000',
          lineHeight: '18px',
          padding: 0,
          borderBottom: 'none',
          height: '20px',
          marginBottom: '-6px',
        },
      },
      '& $activityItem_callRailDiv': {
        maxHeight: 'none',
      },
    },
    '&.isLabeled': {
      borderTop: 'none',
      marginTop: '44px',
    },
    '&.isExpanded': {
      borderTop: 'none',
      margin: '15px 0',
      paddingBottom: '50px',
      '&.isLabeled': {
        marginTop: '44px',
      },
      '& $activityItem_content': {
        paddingTop: '10px',
      },
      '& $activityItem_footer': {
        display: 'block',
      },
    },
    '&.isCallRailCall': {},
  },
  activityItem_note: {},
  activityItem_correspondence: {},
  activityItem_meeting: {},
  activityItem_transition: {},
  activityItem_callRailCall: {
    cursor: 'default',
  },
  activityItem_label: {
    color: '#757575',
    left: 0,
    margin: '10px 5px',
    position: 'absolute',
    top: '-44px',
  },
  activityItem_container: {
    display: 'flex',
    fontSize: '1rem',
  },
  activityItem_profileSection: {
    flex: 'none',
    width: '89px',
    paddingRight: '5px',
  },
  activityItem_profileImage: {
    height: '44px',
    width: '44px',
    margin: '20px auto auto',
  },
  activityImage: {
    position: 'relative',
    '&.isNote': {
      '& $activityImage_secondary': {
        background: '#2196f3',
      },
    },
    '&.isCorrespondence': {
      '& $activityImage_secondary': {
        background: '#ff3465',
      },
    },
    '&.isMeeting': {
      '& $activityImage_secondary': {
        background: '#ff3465',
      },
    },
    '&.isTransition': {
      '& $activityImage_secondary': {
        background: '#2196f3',
      },
    },
  },
  activityImage_primary: {
    overflow: 'hidden',
    borderRadius: '50%',
    '&$profileImageComponent': {
      width: '44px',
      height: '44px',
    },
  },
  activityImage_secondary: {
    background: '#757575',
    position: 'absolute',
    top: '25px',
    left: '22px',
    height: '24px',
    width: '24px',
    borderRadius: '12px',
    border: '2px solid #fff',
    '& i': {
      position: 'absolute',
      // MKM adjusted these visually. Don't know why that was necessary.
      // top: "-2px",
      top: '-1px',
      // left: "3px",
      left: '6px',
      fontSize: '14px',
      lineHeight: '24px',
      color: '#fff',
    },
  },
  /*
   * No longer used.  Superceded by zmdi
  mdf: {
    display: "inline-block",
    fontFamily: "'Material Design Iconic Font'",
    fontSize: "inherit",
    fontStyle: "normal",
    speak: "none",
    textRendering: "auto",
  },
  md_phone: {
    "&::before": {
      // content: "'\\f0ee'",
      content: "'\\f2b8'",
    },
  },
  */
  activityItem_contentSection: {
    position: 'relative',
    flex: 'auto',
    minWidth: 0,
  },
  activityItem_contentWrapper: {
    position: 'relative',
  },
  activityItem_header: {
    color: '#212121',
    fontSize: '115%',
    lineHeight: '22px',
    padding: '19px 35px 0 0',
  },
  activityItem_headerContent: {
    fontSize: 'inherit',
    fontWeight: 500,
  },
  actor_display: {},
  activityItem_date: {
    fontSize: '90%',
    color: '#9e9e9e',
    marginTop: '-3px',

    fontWeight: 400,
  },
  activityItem_content: {
    position: 'relative',
    padding: '0 20px 15px 0',
    '&$u_ellipsis': {
      '& p': {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
    },
  },
  activityItem_callRailDiv: {
    paddingBottom: '6px',
  },
  textArea: {
    border: '0 #000',
    borderBottom: '1px solid rgba(12, 13, 13, 0.16)',
    lineHeight: '18px',
    padding: '5px 0',
    '&.textArea_flat': {
      borderColor: 'transparent',
    },

    // MKM The following are shared with textField
    background: '0 0',
    color: '#212121',
    display: 'inline-block',
    fontSize: 'inherit',
    fontWeight: 400,
    resize: 'none',
    width: '100%',
    outline: 0,
  },
  activityItem_footer: {
    display: 'none',
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    height: '48px',
    padding: '10px',
    backgroundColor: '#eee',
    borderTop: '1px solid #e0e0e0',
  },
});

export default activityListStyles;
